<template>
  <el-container>
    <el-main class="verticalCenter center">
      <div style="width:1600px">
        <el-row type="flex" justify="center">
          <el-col :span="24" style="width: 100%;max-width: 1600px;">
            <el-row>
              <el-col :span="6">
                <div class="page-title">
                  国家基础信息
                </div>
              </el-col>
              <el-col :span="17">
                <div style="width: 10px;height: 10px"></div>
              </el-col>
              <el-col :span="1">
                <div
                  class="page-title close"
                  id="pageClose"
                  @click="$emit('close')"
                >
                  X
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="40" style="margin-bottom: 24px">
              <el-col :span="6">
                <div class="country">
                  <div class="title">
                    <h3>
                      国家
                    </h3>
                    <p>
                      COUNTRY
                    </p>
                  </div>
                  <div class="content" id="CountryList">
                    <div
                      class="item"
                      :class="{ active: country === '马来西亚' }"
                      @click="changeCountry('马来西亚')"
                    >
                      <span class="icon">
                        <img
                          src="@/assets/image/analysis/nalaixiya.png"
                          alt=""
                        />
                      </span>
                      <span class="txt">
                        马来西亚
                      </span>
                    </div>
                    <div
                      class="item"
                      :class="{ active: country === '泰国' }"
                      @click="changeCountry('泰国')"
                    >
                      <span class="icon">
                        <img src="@/assets/image/analysis/taiguo.png" alt="" />
                      </span>
                      <span class="txt">
                        泰国
                      </span>
                    </div>
                    <div
                      class="item"
                      :class="{ active: country === '越南' }"
                      @click="changeCountry('越南')"
                    >
                      <span class="icon">
                        <img
                          src="@/assets/image/analysis/yuenan.png"
                          alt=""
                          width="91"
                        />
                      </span>
                      <span class="txt">
                        越南
                      </span>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="11">
                <div class="people">
                  <div class="title">
                    <h3>
                      国家人口比例
                    </h3>
                    <p>
                      National population ratio
                    </p>
                  </div>
                  <div class="content">
                    <Pie :peopleData="analysisData.population"> </Pie>
                  </div>
                </div>
              </el-col>
              <el-col :span="7">
                <div class="sex">
                  <div class="title">
                    <h3>
                      国家男女比例
                    </h3>
                    <p>
                      National sex ratio
                    </p>
                  </div>
                  <div class="content">
                    <div class="item-wrap">
                      <div class="item">
                        <div class="icon">
                          <img src="@/assets/image/analysis/man.png" alt="" />
                        </div>
                        <p class="info">
                          <span>
                            {{ (analysisData.people.man / 10000).toFixed(2) }}
                          </span>
                          <span>
                            万
                          </span>
                        </p>
                      </div>
                      <div class="item">
                        <div class="icon">
                          <img src="@/assets/image/analysis/women.png" alt="" />
                        </div>
                        <p class="info">
                          <span>
                            {{ (analysisData.people.women / 10000).toFixed(2) }}
                          </span>
                          <span>
                            万
                          </span>
                        </p>
                      </div>
                    </div>
                    <div class="stats">
                      <div
                        class="man"
                        :style="{
                          width: `${(100 * analysisData.people.man) /
                            (analysisData.people.man +
                              analysisData.people.women)}%`,
                        }"
                      >
                        {{
                          (
                            analysisData.people.man /
                            (analysisData.people.man +
                              analysisData.people.women)
                          ).toFixed(2) * 100
                        }}%
                      </div>
                      <div class="women">
                        {{
                          100 -
                            (
                              analysisData.people.man /
                              (analysisData.people.man +
                                analysisData.people.women)
                            ).toFixed(2) *
                              100
                        }}%
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="40">
              <el-col :span="12">
                <div class="price">
                  <div class="content">
                    <Bar
                      type="line"
                      :title="{
                        text: '产品价格(¥)与销量(kg)',
                        subText: 'Product price and sales volume',
                      }"
                      :dataset="analysisData.consumption"
                      xAxisAxisLabelFontSize="12"
                    >
                    </Bar>
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="trade">
                  <div class="content">
                    <Bar
                      type="bar"
                      :title="{
                        text: '传统线下贸易量(kg)',
                        subText: 'Traditional offline trade volume',
                      }"
                      :dataset="analysisData.summary"
                    >
                    </Bar>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import Pie from "@/components/echarts/pie";
import Bar from "@/components/echarts/bar";

export default {
  name: "Analysis",
  components: {
    Pie,
    Bar,
  },
  data() {
    return {
      drawer: false,
      direction: "rtl",
      country: "马来西亚",
      analysisData: {
        people: {},
        summary: { source: [] },
        consumption: { source: [] },
        population: [],
      },
    };
  },
  created() {
    this.getCountryInfo();
  },
  methods: {
    changeCountry(country) {
      this.country = country;
      this.getCountryInfo();
    },
    getCountryInfo() {
      this.$axios
        .post("/student/data/present/people", { country: this.country })
        .then((res) => {
          if (res.succeed) {
            this.analysisData.people = res.items[0];
            this.analysisData.population = [
              { value: res.items[0].china, name: "华人" },
              { value: res.items[0].locale, name: "当地人" },
              { value: res.items[0].other, name: "其他国家人口" },
            ];
          }
        });
      this.$axios
        .post("/student/data/present/trade/summary", { country: this.country })
        .then((res) => {
          if (res.succeed) {
            let source = [
              ["year"],
              ["信阳毛尖"],
              ["大红袍"],
              ["正山小种"],
              ["茉莉花"],
              ["西湖龙井"],
            ];
            source.forEach((item) => {
              res.items.forEach((itemm) => {
                item.push(itemm[item[0]]);
              });
            });
            this.analysisData.summary = { source: source };
          }
        });
      this.$axios
        .post("/student/data/present/consumption", { country: this.country })
        .then((res) => {
          if (res.succeed) {
            let source = [["price"], ["大红袍"], ["正山小种"], ["茉莉花茶"]];
            source.forEach((item) => {
              res.items.forEach((itemm) => {
                item.push(itemm[item[0]]);
              });
            });
            this.analysisData.consumption = { source: source };
            setTimeout(() => {
              console.log(JSON.stringify(this.analysisData));
            }, 5000);
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
@mixin title {
  padding: 30px 30px 0 30px;
  margin-bottom: 10px;
  h3 {
    font-size: 26px;
    font-weight: bold;
    line-height: 33px;
  }
  p {
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;
    color: #999999;
  }
}

::v-deep .el-drawer.rtl {
  border-radius: 12px 0 0 12px;
}

.page-title {
  font-size: 30px;
  font-weight: bold;
  background: white;
  display: inline-block;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 24px;

  &.close {
    box-shadow: 0 0 4px #cacaca;
    cursor: pointer;
  }
}

div.drawer-title {
  .txt {
    font-size: 26px;
    font-weight: bold;
    line-height: 33px;
    color: #454b60;
  }

  .sub-txt {
    font-size: 12px;
    font-family: Microsoft YaHei UI;
    font-weight: 400;
    line-height: 15px;
    color: #999999;
  }
}

div.drawer-content {
  padding: 0 30px 24px 30px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .form-wrap {
    flex: 1;

    .select-country {
      box-shadow: 0px 0px 20px rgba(158, 158, 158, 0.47);
      height: 230px;
      border-radius: 12px;
      border: 2px solid #f1f1f1;
      display: flex;
      margin-bottom: 42px;

      .product {
        width: 230px;
        border-right: 1px solid #f1f1f1;
        padding: 8px;

        img {
          max-width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .select {
        display: flex;
        justify-content: center;
        flex: 1;

        .item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 22px;
          color: #999999;

          button {
            margin-top: 30px;
            width: 82px;
            height: 33px;
            background: linear-gradient(312deg, #005be7 0%, #70a0eb 100%);
            box-shadow: 0px 3px 6px rgba(0, 91, 231, 0.3);
            border-radius: 60px;
            font-size: 14px;
            color: white;
            font-family: "Microsoft YaHei", sans-serif;
          }
        }
      }
    }

    .form-data {
      .label {
        height: 18px;
        font-size: 14px;
        font-family: Microsoft YaHei UI, sans-serif;
        font-weight: 400;
        line-height: 18px;
        color: #999999;
        margin-bottom: 8px;
      }

      .input {
        textarea {
          resize: none;
          padding: 8px 18px;
          width: 100%;
          height: 73px;
          background: #ffffff;
          border: 2px solid #f1f1f1;
          border-radius: 12px;
          font-size: 16px;
          font-family: Microsoft YaHei UI, sans-serif;
          font-weight: 400;
        }

        input {
          padding: 0 18px;
          font-size: 16px;
          height: 54px;
          background: #ffffff;
          border: 2px solid #f1f1f1;
          border-radius: 12px;
        }
      }
    }

    .form-title {
      margin-bottom: 18px;
    }

    .form-price-inventory {
      display: flex;
      justify-content: space-between;
      margin-bottom: 18px;
    }
  }

  .other-country {
    display: flex;
    justify-content: space-between;

    .other-item {
      width: 165px;
      height: 111px;
      background: #ffffff;
      border: 2px solid #f1f1f1;
      border-radius: 12px;
      overflow: hidden;

      .select-country {
        height: 100%;
        border-radius: 12px;
        display: flex;
        margin-bottom: 20px;

        .product {
          width: 111px;
          height: 100%;
          border-right: 1px solid #f1f1f1;

          img {
            max-width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .select {
          display: flex;
          justify-content: center;
          flex: 1;

          .item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-size: 10px;
            color: #999999;

            button {
              margin-top: 10px;
              width: 39px;
              height: 18px;
              background: linear-gradient(312deg, #005be7 0%, #70a0eb 100%);
              box-shadow: 0px 3px 6px rgba(0, 91, 231, 0.3);
              border-radius: 60px;
              font-size: 10px;
              color: white;
              font-family: "Microsoft YaHei", sans-serif;
            }
          }
        }
      }
    }
  }
}

.mark {
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #005be7;
  color: white;
  text-align: center;
  line-height: 30px;
}

.nav {
  padding: 0 20%;
  height: 84px;
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .nav-item {
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 30px;
    font-family: Microsoft YaHei UI, serif;
    font-weight: bold;
    color: #333333;
    padding: 0 16px;
    margin-right: 160px;
    position: relative;

    .name {
      .txt {
      }

      .sub-txt {
        margin-top: 8px;
        text-align: center;
        font-size: 10px;
        font-weight: 400;
        text-transform: uppercase;
      }
    }

    &.active {
      color: #005be7;

      .name .sub-txt {
        color: #005be7;
      }
    }

    &.active:before {
      content: "";
      position: absolute;
      bottom: 0;
      left: -15px;
      width: calc(100% + 30px);
      height: 8px;
      background: #005be7;
    }

    &:last-child {
      margin-right: 0;
    }
  }
}

.title {
  @include title;
}

.country {
  height: 418px;
  background: #ffffff;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  opacity: 1;
  border-radius: 12px;

  .content {
    .item {
      cursor: pointer;
      display: flex;
      align-items: center;
      position: relative;
      height: 108px;

      &.active {
        background: #f1f1f1;
      }

      &.active:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 6px;
        height: 100%;
        background: linear-gradient(180deg, #70a0eb 0%, #005be7 100%);
      }

      span.icon {
        padding-left: 20px;
        margin-right: 110px;
      }

      span.txt {
        font-size: 22px;
        font-weight: 400;
        line-height: 28px;
        color: #999999;
      }
    }
  }
}

.people {
  height: 418px;
  background: #ffffff;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  opacity: 1;
  border-radius: 12px;

  .title {
    @include title;
  }

  .content {
  }
}

.sex {
  height: 418px;
  background: #ffffff;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  opacity: 1;
  border-radius: 12px;

  .title {
    @include title;
  }

  .content {
    padding: 20px;

    .item-wrap {
      padding: 0 18px 0 18px;
      margin-bottom: 34px;
      display: flex;
      justify-content: space-between;

      .item {
        .icon {
          width: 120px;
          height: 120px;

          img {
            object-fit: cover;
          }
        }

        .info {
          span {
            &:first-child {
              display: inline-block;
              min-width: 140px;
              height: 40px;
              font-size: 40px;
              font-family: Bahnschrift, serif;
              font-weight: bold;
              line-height: 56px;
              color: #666666;
              letter-spacing: 0;
            }

            &:last-child {
              font-size: 14px;
              font-weight: 400;
              line-height: 18px;
              color: #999999;
            }
          }
        }
      }
    }

    .stats {
      height: 50px;
      background: #f1f1f1;
      border-radius: 100px;
      display: flex;
      padding: 8px;

      .man,
      .women {
        border-radius: 100px;
        height: 100%;
        font-size: 30px;
        font-family: Bahnschrift, serif;
        font-weight: bold;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: width 0.3s linear;
      }

      .man {
        background: linear-gradient(90deg, #005be7 0%, #70a0eb 100%);
        margin-right: 8px;
      }

      .women {
        background: linear-gradient(90deg, #fe4a49 0%, #ff7e7e 100%);
        flex-grow: 1;
        flex-shrink: 1;
      }
    }
  }
}

.price,
.trade {
  height: 388px;
  background: #ffffff;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  opacity: 1;
  border-radius: 12px;

  .title {
    @include title;
    position: absolute;
  }
}
</style>
